import { jsx as _jsx } from "react/jsx-runtime";
import { isUndefined, omit } from '../../utils';
import { PurchaseMotionButtonPropsInterface, MergedPurchaseMotionProps } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionPropsInterface';
import { purchaseMotionButtons, purchaseMotionButtonPropsInterface } from 'ui-addon-upgrades/_core/common/constants/purchaseMotions'; // @ts-expect-error dependency missing types

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { UPGRADE_POINT_LOCATIONS } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';

const PurchaseMotionButton = props => {
  const {
    upgradeData: {
      upgradeProduct
    },
    trackingSource,
    purchaseMotions,
    level,
    passthroughProps = {},
    overrides = {},
    location
  } = props;
  const purchaseMotion = purchaseMotions[level - 1];
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const mappedButtonPassthroughProps = passthroughProps[purchaseMotion] || {};
  const mappedButtonPropsInterface = purchaseMotionButtonPropsInterface[purchaseMotion];
  const MappedButtonComponent = overrides[purchaseMotion] || purchaseMotionButtons[purchaseMotion];

  if (isUndefined(MappedButtonComponent) || isUndefined(mappedButtonPropsInterface)) {
    return null;
  }

  const propsToKeep = [...Object.keys(mappedButtonPropsInterface), 'upgradeData', 'use'];
  const propsToOmit = Object.keys(omit(Object.assign({}, PurchaseMotionButtonPropsInterface, {}, MergedPurchaseMotionProps), propsToKeep));
  const propsToPass = omit(props, propsToOmit);
  const apiName = UpgradeProductToApiNameMap[upgradeProduct];
  return /*#__PURE__*/_jsx(MappedButtonComponent, Object.assign({
    "data-selenium-id": `${trackingSource}-${apiName}-${purchaseMotion}-button`,
    "data-reagan-primary-cta": true,
    truncate: true,
    isUpgradePoint: isUpgradePoint,
    level: level
  }, mappedButtonPassthroughProps, {}, propsToPass));
};

PurchaseMotionButton.propTypes = PurchaseMotionButtonPropsInterface;
export default PurchaseMotionButton;